module.exports = __webpack_public_path__ + "img/selected7-min.2c114241.png";